import React, { useCallback, useContext, useEffect, useState } from 'react'
import { CityDropdownForTrip, CommonCityStateDropdown, CommonInput, CommonSwitch, CrossButton, CustomSelect, VehicleDropdownForTrip } from 'components'
import { errorSchema, utils } from 'helper';
import { City, State } from "country-state-city";
import Dropdown from 'components/common/Customdropdown/Dropdown';
import StorageService from "utils/StorageServices/StorageServices";
import { UserContext } from "context";
import debounce from 'lodash.debounce';
import toast, { Toaster } from 'react-hot-toast';
import { createConsignor, editConsignor, getAllConsignorgGroup, getConsignorListData } from '_services/accountsServices/consignorServices';
import { AddButton } from 'components/common/CommonButton';
import { constant } from 'constants/constant';
import { getAllVehicleNumber, getStatesData, handleKeyDown } from '_services';
import { getCityLocationList } from '_services/accountsServices/cityLocationService';
import AddLocationModal from 'modals/AddLocationModal';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import { TimeLine } from 'modals/TimeLineEwayModal';
import { IoCloseCircle } from 'react-icons/io5';
import { createVehicleDocuments, deleteImageVehicleDocument, editVehicleDocuments, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel';
import { Images } from 'constants';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { StorageServices } from 'utils';

let insuranceObjId = "Insurance" // "685bdb4c7297b8fc1e052f43"

const getFormattedDate = (is_date = '') => {
  const today = is_date ? new Date(is_date) : new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}/${month}/${day}`;
}

const formObj = {
  company_id: StorageService.getCompanyId(),
  vehicle_no: '',
  doc_type_id: {},
  document_no: '',
  issue_date: new Date(),
  expiry_date: '',
  is_reminder: true,
  file: [],
  reminder_date: '', // new Date()?.setDate(new Date()?.getDate() - 15)
  reminder_days: '', // { label: "15 Days before", value: 15 }
}

const AddEditVehicleDocumentsModal = (props) => {
  let { isOpen, onClose, isPreviousModal, showingPrefield, withoutFirstModalDirectLrOpen, isTrue = false, isEwayBillTrue = false, callbackData = () => { }, callListApi = () => { } } = props;

  const { masterData, setCreateDocument } = useContext(UserContext);
  let isDetails = (isOpen?.editDocument === true && isOpen?.viewDocument === true);
  const [formValue, setFormValue] = useState(formObj);
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);
  const [documentTypeList, setDocumentTypeList] = useState([])
  const [activeTab, setActiveTab] = useState(1);

  const [vehicleDocTypeModel, setVehicleDocTypeModel] = useState(false);

  const handleOnChange = async (name, value) => {
    const stateObj = { ...formValue, [name]: value };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(stateObj, errorSchema.insuranceSchema);
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const apiCallingFunction = async () => {
    try {
      if (isOpen?.editDocument) {
        const formData = new FormData();
        formData.append("vehicle_no", isOpen?.vehicle_no);
        formData.append("doc_type_id", formValue?.doc_type_id?.value);
        formData.append("issue_date", getFormattedDate(formValue?.issue_date));
        formData.append("expiry_date", getFormattedDate(formValue?.expiry_date));
        formData.append("company_id", StorageService.getCompanyId());
        formData.append("is_reminder", formValue?.is_reminder);
        if (formValue?.is_reminder) {
          formData.append("reminder_date", getFormattedDate(formValue?.reminder_date));
          formData.append("reminder_days", formValue?.reminder_days?.value);
        }
        if (formValue?.document_no) {
          formData.append("document_no", formValue?.document_no);
        }
        if (formValue?.company_name && formValue?.doc_type_id?.label === insuranceObjId) {
          formData.append("company_name", formValue?.company_name);
        }
        // if (formValue?.file?.length > 0) {
        //   formValue?.file?.forEach((key, index) => {
        //     formData.append('files', key);
        //   });
        // }

        if (formValue?.file?.length > 0) {
          formValue?.file?.forEach((key) => {
            if (key instanceof File) {
              formData.append('files', key);
            } else {
              formData.append('doc_file', key);
            }
          });
        }
        const res = await editVehicleDocuments(formData, isOpen?._id);
        if (res?.responseCode == 200) {
          if (res?.responseMessage) {
            toast.success(res?.responseMessage);
          }
          setLoading(false);
          setFormValue({});
          onClose();
          callListApi();
        } else {
          setLoading(false);
          if (res?.responseMessage) {
            toast.error(res?.responseMessage);
          }
        }
        setCreateDocument(false);
      } else {
        const formData = new FormData();
        formData.append("vehicle_no", isOpen?.vehicle_no);
        formData.append("doc_type_id", formValue?.doc_type_id?.value);
        formData.append("issue_date", getFormattedDate(formValue?.issue_date));
        formData.append("expiry_date", getFormattedDate(formValue?.expiry_date));
        formData.append("company_id", StorageService.getCompanyId());
        formData.append("is_reminder", formValue?.is_reminder);
        if (formValue?.is_reminder) {
          formData.append("reminder_date", getFormattedDate(formValue?.reminder_date));
          formData.append("reminder_days", formValue?.reminder_days?.value);
        }
        if (formValue?.document_no) {
          formData.append("document_no", formValue?.document_no);
        }
        if (formValue?.company_name && formValue?.doc_type_id?.label === insuranceObjId) {
          formData.append("company_name", formValue?.company_name);
        }
        if (formValue?.file?.length > 0) {
          formValue?.file.forEach((key, index) => {
            formData.append('files', key);
          });
        }
        const res = await createVehicleDocuments(formData);
        if (res?.responseCode == 200) {
          if (res?.responseMessage) {
            toast.success(res?.responseMessage);
          }
          setLoading(false);
          setFormValue({});
          onClose();
          callListApi();
        } else {
          setLoading(false);
          if (res?.responseMessage) {
            toast.error(res?.responseMessage);
          }
        }
      }
      setCreateDocument(false);
    } catch (error) {
      setLoading(false);
      setCreateDocument(false);
    }
  }

  const handleClick = async (e) => {
    e.preventDefault();
    const validationResult = await utils?.checkFormError(formValue, errorSchema.insuranceSchema);
    if (utils?.isObjectKeyEmpty(validationResult)) {
      setLoading(true);
      await apiCallingFunction(true);
      setFormError("");
    } else {
      setFormError(validationResult);
      setLoading(false);
    }
  };

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...formValue, [name]: item };
    setFormValue(stateObj);

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(stateObj, errorSchema.insuranceSchema);
      if (validationResult === true) {
        setFormError({});
      } else {
        setFormError(validationResult);
      }
    }
  };

  const getDocumentType = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        limit: 100,
        offset: 1,
        // search: '',
      }
      const res = await getVehicleDocTypeListData(object);
      if (res?.responseCode == 200) {
        let data = res?.data?.docTypes?.map((el) => {
          return {
            label: el?.name,
            value: el?._id,
            id: el?.id
          }
        })
        setDocumentTypeList(data);
      }
    } catch (error) { }
  }

  useEffect(() => {
    if (isOpen?.addDocument) {
      setFormValue((s) => ({
        ...s,
        doc_type_id: isOpen?.doc_type_id,
        issue_date: new Date(),
      }))
    }
    if (isOpen?.editDocument) {
      setFormValue((s) => ({
        ...s,
        company_id: isOpen?.company_id,
        company_name: isOpen?.company_name,
        vehicle_no: isOpen?.vehicle_no,
        doc_type_id: { label: isOpen?.doc_type_id?.name, value: isOpen?.doc_type_id?._id, id: isOpen?.doc_type_id?.id },
        document_no: isOpen?.document_no,
        issue_date: isOpen?.issue_date,
        expiry_date: isOpen?.expiry_date,
        is_reminder: (isOpen?.is_reminder != null ? isOpen?.is_reminder : false),
        file: isOpen?.doc_file,
        reminder_date: isOpen?.reminder_date,
        reminder_days: constant?.dueDateArray?.find((el) => el?.value === isOpen?.reminder_days)
      }))
    }
    getDocumentType();
  }, [isOpen, constant?.dueDateArray])

  const handleFileChange = async (e) => {
    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg", "image/webp"];

    if (!allowedTypes.includes(e?.target?.files[0]?.type)) {
      e.target.value = "";
      toast.error("Only PDF and image files are allowed");
      return;
    }

    const selectedFiles = Array.from(e.target.files);
    const existingFiles = formValue?.file || [];

    const newFiles = selectedFiles.filter(newFile =>
      !existingFiles.some(existingFile =>
        existingFile.name === newFile.name &&
        existingFile.size === newFile.size &&
        existingFile.type === newFile.type
      )
    );
    const totalFiles = existingFiles.length + newFiles.length;

    if (totalFiles > 5) {
      toast.error("Maximum file limit is 5.");
      return;
    }

    const updatedFileArray = [...existingFiles, ...newFiles];

    handleOnChange("file", updatedFileArray);
  };

  const deleteImageFunction = async (data) => {
    try {
      let object = {
        doc_id: formValue?.doc_type_id?.value,
        file_path: data,
      }
      const res = await deleteImageVehicleDocument(object);
      if (res?.responseCode === 200) {
        if (res?.responseMessage) {
          toast.success("Image deleted successfully");
        }
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
      }
    } catch (error) {
    }
  }

  const handleDeleteImage = async (item, index) => {
    let images = [...formValue?.file];
    images.splice(index, 1)
    setFormValue((s) => ({
      ...s,
      file: images,
    }))
    if (!item?.name) {
      deleteImageFunction(item);
    }
  }

  const closeModelHandler = () => {
    setCreateDocument(false);
    onClose(false);
  }

  const callSelectDateWiseFunction = (date, data) => {
    let finalDate = utils.getReminderDate(date, data?.value)
    setFormValue((s) => ({
      ...s,
      reminder_date: finalDate
    }))
  }

  useEffect(() => {
    // if (isOpen?.addDocument) {
    if (formValue?.expiry_date && !isOpen?.editDocument) {
      handleOnChange("reminder_date", utils.getReminderDate(formValue?.expiry_date, 15));
      setFormValue((s) => ({
        ...s,
        reminder_date: utils.getReminderDate(formValue?.expiry_date, 15),
        reminder_days: { label: "15 Days before", value: 15 },
      }))
    }
    // }
  }, [isOpen, formValue?.expiry_date])

  useEffect(() => {
    if (isOpen?.editDocument && formValue?.expiry_date && formValue?.is_reminder) {
      handleOnChange("reminder_date", utils.getReminderDate(formValue?.expiry_date, 15));
      setFormValue((s) => ({
        ...s,
        reminder_date: utils.getReminderDate(formValue?.expiry_date, 15),
        reminder_days: { label: "15 Days before", value: 15 },
      }))
    }
  }, [isOpen?.editDocument, formValue?.is_reminder])

  const toggleVehicleDocTypeModel = () => {
    setVehicleDocTypeModel(!vehicleDocTypeModel);
  };

  const selectCategory = (data) => {
    setFormValue((s) => ({
      ...s,
      doc_type_id: { label: data?.name, value: data?._id }
    }))
  }

  let vehicleDocTypeModelProps = {
    isOpen: vehicleDocTypeModel,
    closeModal: (e) => setVehicleDocTypeModel(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: vehicleDocTypeModel?.isDetails ? "View Document Type" : (vehicleDocTypeModel?._id ? 'Update Document Type' : 'Add Document Type'),
    submitTitle: vehicleDocTypeModel?.isDetails ? "View Document Type" : (vehicleDocTypeModel?._id ? 'Update Document Type' : 'Add Document Type'),
    footerPart: vehicleDocTypeModel?.isDetails ? true : false,
    hideFooterSumbmitBtn: vehicleDocTypeModel?.isDetails ? true : false,
    hideCompletelyFoolter: vehicleDocTypeModel?.isDetails ? true : false,
    ApiCall: (e) => getDocumentType(e),
    categorySelection: (value) => selectCategory(value)
  }

  const fetchVehicle = async (search, page, limit) => {
    const res = await getAllVehicleNumber({
      company_id: StorageServices?.getCompanyId(),
      offset: page,
      limit,
      search,
      vehicle_ownership: [1, 2, 3]
    });
    if (res?.responseCode === 200) {
      const list = res?.data?.vehicle_list?.map((i) => ({
        ...i,
        name: `${i?.vehicle_no}`,
        ownershipStatus: i?.vehicle_ownership,
      }));
      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      return { items: [], total: 0 };
    }
  };

  // const handleVehicleChange = (data) => {
  //       setFormValue((prev) => ({
  //           ...prev,
  //           vehicle_id: data,
  //       }))

  //       if (formError.vehicle_id) {
  //           setFormError(prev => ({ ...prev, vehicle_id: "" }))
  //       }
  //   }

  return (
    <>
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">{isOpen?.viewDocument ? 'View Document' : (isOpen?.editDocument ? 'Update Document' : 'Add Document')}</h5>
        <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => closeModelHandler()}>
          <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
              fill="black" />
          </svg>
        </CrossButton>
      </div>

      <div className="offcanvas-body">
        <div className='addPr_flBx __doctument_cgt mt-2'>
          <ul className="nav nav-tabs cstNew_tabs" id="addParty" role="tablist">
            {constant.vehicleDocumentTabs?.map((item, indx) => (
              <li
                className="nav-item"
                role="presentation"
                key={indx + item?.value}
              >
                <button
                  className={
                    "nav-link " + (activeTab === item?.id ? "active" : "")
                  }
                  type="button"
                  aria-selected={activeTab === item?.id}
                  onClick={(e) => setActiveTab(item.id)}
                >
                  {item?.title}
                </button>
              </li>
            ))}

          </ul>

          {activeTab === 1 && (
            <div className='pr_procssBx' id="addPartyContent">
              <div className='pr_procssBx_grid'>
                <div className='singleDiv'>
                  <CustomSelect
                    options={documentTypeList}
                    name="doc_type_id"
                    label="Document Type"
                    value={formValue?.doc_type_id}
                    error={formError["doc_type_id.label"]}
                    onSelect={(data) => onhandleSelect(data, 'doc_type_id')}
                    placeholder="Document Type"
                    disabled={isOpen?.onlyOneFieldDisable ? true : (isDetails ? true : (isOpen?.isCategoryDisable ? true : false))}
                    isAddButton={true}
                    addButtonAction={(e) => toggleVehicleDocTypeModel(e)}
                  />
                </div>

                <div className='singleDiv'>
                  <CommonInput
                    type="text"
                    placeholder="Document Number"
                    label="Document Number"
                    name='document_no'
                    disabled={isDetails ? true : false}
                    value={formValue.document_no}
                    focus={!!(typeof formError === "object" && formError?.document_no)}
                    error={!!(typeof formError === "object") ? formError?.document_no : ""}
                    maxLength="16"
                    onInput={utils.maxLengthCheck}
                    onChange={({ target: { name, value } }) => {
                      if (/^[a-zA-Z0-9]*$/.test(value)) {
                        handleOnChange(name, value);
                      }
                    }}
                  />
                </div>

                {(formValue?.doc_type_id?.label === insuranceObjId) ? <div className='singleDiv'>
                  <CommonInput
                    type="text"
                    placeholder="Company Name"
                    label="Company Name"
                    name='company_name'
                    value={formValue.company_name}
                    disabled={isDetails ? true : false}
                    focus={!!(typeof formError === "object" && formError?.company_name)}
                    error={!!(typeof formError === "object") ? formError?.company_name : ""}
                    maxLength="40"
                    onInput={utils.maxLengthCheck}
                    onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                  // onChange={({ target: { name, value } }) =>
                  //   handleOnChange(name, value)
                  // }
                  />
                </div> : <></>}

                <div className='singleDiv'>
                  <DatePickerComponent
                    label="Issue Date "
                    name="issue_date"
                    showTimeSelect={false}
                    defaultTimeFix={false}
                    disabled={isDetails ? true : false}
                    // min={new Date()}
                    startDate={formValue?.issue_date}
                    onChange={(data) => handleOnChange('issue_date', data)}
                    error={!!(typeof formError === "object") ? formError?.issue_date : ""}
                  />
                </div>

                <div className='singleDiv'>
                  <DatePickerComponent
                    label="Expiry Date "
                    name="expiry_date"
                    // min={new Date()}
                    showTimeSelect={false}
                    defaultTimeFix={false}
                    disabled={isDetails ? true : false}
                    startDate={formValue?.expiry_date}
                    onChange={(data) => handleOnChange('expiry_date', data)}
                    error={!!(typeof formError === "object") ? formError?.expiry_date : ""}
                  />
                </div>

                <div className="singleDiv" style={{ marginLeft: "5px" }}>
                  <CommonSwitch
                    id="is_reminder"
                    name="is_reminder"
                    label="Reminder"
                    disabled={isDetails ? true : false}
                    checked={formValue.is_reminder ? true : false}
                    onChange={(e) => setFormValue((s) => ({ ...s, is_reminder: e?.target?.checked }))}
                  />
                </div>
                {
                  formValue.is_reminder ? <>
                    <div className='singleDiv' style={{ position: 'relative' }}>
                      <DatePickerComponent
                        label="Reminder Date "
                        name="reminder_date"
                        disabled
                        showTimeSelect={false}
                        defaultTimeFix={false}
                        max={formValue?.expiry_date}
                        startDate={formValue?.reminder_date}
                        onChange={(data) => handleOnChange('reminder_date', data)}
                        error={!!(typeof formError === "object") ? formError?.reminder_date : ""}
                      />
                      <div className='__inrDropdown_bx'>
                        <CustomSelect
                          options={constant.dueDateArray}
                          name="reminder_days"
                          disabled={isDetails ? true : (!formValue?.expiry_date ? true : false)}
                          placeholder="Select Days"
                          value={formValue?.reminder_days?.value ? formValue?.reminder_days : {}}
                          onSelect={(data) => {
                            onhandleSelect(data, 'reminder_days');
                            callSelectDateWiseFunction(formValue?.expiry_date, data);
                          }}
                        />
                      </div>
                    </div>
                  </>
                    : <></>
                }

                <div className='singleDiv'>
                  <label className="attachFilelabel">
                    <span className="title"> + Attachment </span>
                    <input
                      className="FileUpload1"
                      name="booking_attachment"
                      id="file-input"
                      onChange={(e) => handleFileChange(e)}
                      type="file"
                      disabled={isDetails ? true : false}
                      multiple
                    />
                  </label>
                  {formError?.file && (
                    <span className="input_drop_error">
                      {formError?.file}
                    </span>
                  )}
                  <div className='img_fnex_src'>
                    {
                      formValue?.file?.length > 0 &&
                      formValue?.file?.map((file, indx) => {
                        return (
                          <>
                            <div className='pos-relative _img_borderBox'>
                              {isOpen?.addDocument ?
                                <>
                                  {
                                    file?.name?.split('.')?.at(-1) === 'pdf' ?
                                      <img className='_vehicleDoc_Icon'
                                        src={Images.VEH_PDF_ICON.default}
                                        style={{ objectFit: 'contain', objectPosition: 'center' }}
                                        alt={file?.name}
                                      /> : ((file?.name?.split('.')?.at(-1) === 'xlsx' || file?.name?.split('.')?.at(-1) === 'xls' || file?.name?.split('.')?.at(-1) === 'txt' || file?.name?.split('.')?.at(-1) === 'ics') ?
                                        <img className='_vehicleDoc_Icon'
                                          src={Images.VEH_XLXS_ICON.default}
                                          style={{ objectFit: 'contain', objectPosition: 'center' }}
                                          alt={file?.name}
                                        /> :
                                        <img className='_vehicleDoc_Icon'
                                          src={file?.name ? URL?.createObjectURL(file) : ''}
                                          alt={file?.name}
                                        />
                                      )
                                  }
                                </> :
                                <>
                                  {
                                    file?.name ?
                                      file?.name?.split('.')?.at(-1) === 'pdf' ?
                                        <img className='_vehicleDoc_Icon'
                                          src={Images.VEH_PDF_ICON.default}
                                          style={{ objectFit: 'contain', objectPosition: 'center' }}
                                          alt={file?.name}
                                        /> : ((file?.name?.split('.')?.at(-1) === 'xlsx' || file?.name?.split('.')?.at(-1) === 'xls' || file?.name?.split('.')?.at(-1) === 'txt' || file?.name?.split('.')?.at(-1) === 'ics') ?
                                          <img className='_vehicleDoc_Icon'
                                            src={Images.VEH_XLXS_ICON.default}
                                            style={{ objectFit: 'contain', objectPosition: 'center' }}
                                            alt={file?.name}
                                          /> :
                                          <img className='_vehicleDoc_Icon'
                                            src={file?.name ? URL?.createObjectURL(file) : ''}
                                            alt={file?.name}
                                          />
                                        )
                                      : file?.split('.')?.at(-1) === 'pdf' ?
                                        <img className='_vehicleDoc_Icon'
                                          src={Images.VEH_PDF_ICON.default}
                                          style={{ objectFit: 'contain', objectPosition: 'center' }}
                                          alt={file?.name}
                                        /> : ((file?.split('.')?.at(-1) === 'xlsx' || file?.split('.')?.at(-1) === 'xls' || file?.split('.')?.at(-1) === 'txt') ?
                                          <img className='_vehicleDoc_Icon'
                                            src={Images.VEH_XLXS_ICON.default}
                                            style={{ objectFit: 'contain', objectPosition: 'center' }}
                                            alt={file?.name}
                                          /> :
                                          <img className='_vehicleDoc_Icon'
                                            src={`${masterData?.s3_url}${file}`}
                                            alt={file?.name}
                                          />
                                        )
                                  }
                                </>
                              }

                              <a className="p_colored" href={file?.name ? URL?.createObjectURL(file) : `${masterData?.s3_url}${file}`} target="_blank" alt="preview">
                                Document <span>{file?.name ? file?.name : file}</span>
                              </a>

                              {!isDetails && <span className='_clDel_icon' onClick={(e) => handleDeleteImage(file, indx)}>
                                <IoCloseCircle />
                              </span>}
                            </div>
                          </>
                        )
                      })
                    }
                  </div>

                </div>

                {/* {!isDetails && <div className="singleDiv" style={{ marginLeft: "5px" }}>
                  <CommonSwitch
                    id="addExpense"
                    name="addExpense"
                    label="Add Expense"
                  />
                </div>} */}

              </div>
            </div>
          )}

          {activeTab === 2 && (
            <TimeLine timeLineArray={isOpen?.timeline} documentFormate={true} />
          )}

        </div>
      </div>

      {activeTab === 1 && <div className='offcanvas-footer'>
        {!isDetails &&
          <AddButton onClick={handleClick} disabled={loading} name={loading ? 'Loading...' : (isOpen?.editDocument ? 'Update & Save' : 'Add Document')} />}
        <button className='_cancel_btn _avPointer' onClick={() => closeModelHandler()} >Cancel</button>
      </div>}

      {
        vehicleDocTypeModel
        && (
          <AddEditVehicleDocTypeModel {...vehicleDocTypeModelProps} />
        )
      }

    </>
  )
}

export default React.memo(AddEditVehicleDocumentsModal)